
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/xbg",
      function () {
        return require("private-next-pages/xbg/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/xbg"])
      });
    }
  